var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "article-wrapper"
  }, [_c("a-list", {
    attrs: {
      "item-layout": "vertical",
      "data-source": _vm.data,
      size: "large"
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function (item) {
        return _c("a-list-item", {}, [_c("template", {
          slot: "actions"
        }, [_c("span", [_c("a-icon", {
          staticStyle: {
            "margin-right": "8px"
          },
          attrs: {
            type: "star-o"
          }
        }), _vm._v(" " + _vm._s(item.star))], 1), _c("span", [_c("a-icon", {
          staticStyle: {
            "margin-right": "8px"
          },
          attrs: {
            type: "like-o"
          }
        }), _vm._v(" " + _vm._s(item.like))], 1), _c("span", [_c("a-icon", {
          staticStyle: {
            "margin-right": "8px"
          },
          attrs: {
            type: "message"
          }
        }), _vm._v(" " + _vm._s(item.message))], 1)]), _c("a-list-item-meta", [_c("a", {
          staticStyle: {
            "font-size": "1rem"
          },
          attrs: {
            slot: "title",
            href: item.url,
            target: "_blank"
          },
          slot: "title"
        }, [_vm._v(_vm._s(item.title))]), _c("div", {
          staticClass: "listDescription",
          attrs: {
            slot: "description"
          },
          slot: "description"
        }, [_vm._l(item.tagList, function (tag) {
          return [_c("a-tag", {
            key: tag.title,
            staticStyle: {
              "margin-bottom": "6px"
            },
            attrs: {
              color: tag.color
            }
          }, [_vm._v(" " + _vm._s(tag.title) + " ")])];
        }), _vm._v(" " + _vm._s(item.time) + " "), _c("div", {
          staticStyle: {
            margin: "7px 0 5px"
          }
        }, [_vm._v(_vm._s(item.description))])], 2)])], 2);
      }
    }])
  }, [_vm.data.length > 0 ? _c("div", {
    staticStyle: {
      "text-align": "center",
      "margin-top": "16px"
    },
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("a-button", {
    attrs: {
      loading: _vm.loadingMore
    },
    on: {
      click: _vm.loadMore
    }
  }, [_vm._v("加载更多")])], 1) : _vm._e()])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };